(function($) {
    if (typeof Drupal !== "undefined") {
        Drupal.behaviors.custom_theme_file = {
            attach: function(context, settings) {
                init();
            }
        };
    } else {
        init();
    }

    function init() {

        // ДОБАВЛЯЕМ ОБЕРТКУ SPAN В ТАБЛИЦУ В ПЕРВУЮ ЯЧЕЙКУ
        $(".teaser-node-unit-catalog table tr").each(function () {
            $(this).find("td").wrapInner("<span></span>");
        });
        // КОНЕЦ

        // $.widget("ui.dialog", $.ui.dialog, {
        //     open: function() {
        //         // console.log( "open" );
        //         // console.log( this );
        //         // jQuery('body').pageScrollHide();
        //         $(".ui-dialog").once().wrap("<div class=\"ui-dialog-wrapper\"></div>");
        //         return this._super();
        //     },
        //     close: function() {
        //         console.log("dialog destroy");
        //         // удалим из диалогового окна кнопку сворачивания/разворачивания
        //         // this.element.parent().find('.ui-dialog-titlebar-hideshow').remove();
        //         $(".ui-dialog-wrapper, .ui-widget-overlay").remove();
        //         // вызовем в деструктор родительского плагина, который удалит
        //         // оставшиеся следы диалогового окна
        //         // $.ui.dialog.prototype.destroy.call(this);
        //         // $.ui.dialog.prototype.destroy.apply(this, arguments);
        //         // jQuery('body').pageScrollShow();
        //     },
        // });
        // jQuery('.ui-dialog-titlebar-close').on("click", function() {
        //     jQuery('body').pageScrollShow();
        // });

        // ЗАМЕНЯЕМ ДАТУ В НОВОСТЯХ
        const months = ["ЯНВ", "ФЕВ", "МАР", "АПР", "МАЙ", "ИЮН", "ИЮЛ", "АВГ", "СЕН", "ОКТ", "НОЯ", "ДЕК"];
        document.querySelectorAll(".teaser-node-news-teaser-1").forEach((teaser) => {
            let date = teaser.querySelector(".field-date .value");
            if (!date.parentElement.classList.contains("js-date-processed")) {
                let dateValue = date.innerText;
                date.parentElement.classList.add("js-date-processed");
                dateValue = dateValue.split(".");
                date.innerHTML = `${months[dateValue[1]-1]}<div>${dateValue[1]}</div>`;
            }
        });
        // end

    }

    $(document).ready(function(){

        jQuery(".kint-parent").on("click", function(){
            jQuery(this).next().toggle();
        });

        $("table").each(function(){
            if ( !$(this).parents(".dev-modal").length && ( $(this).width() > $(this).parent().width() ) ) {
                var marginBottom = $(this).css("margin-bottom");
                $(this).wrap("<div class=\"table-wrapper\" style=\"margin-bottom: " + marginBottom + "\"></div>");
                $(this).css({"margin-bottom":"0"});
                if ( !$(this).hasClass("nostyle") ) {
                    $(this).addClass("table-no-hover");
                }
            }
        });
        if ( $(".table-wrapper").length ) {
            $(".table-wrapper").mCustomScrollbar({
                alwaysShowScrollbar: 0,
                axis: "x",
                scrollbarPosition: "outside"
            });
        }
        if ( $(".lightgallery").length ) {
            lightGallery(".lightgallery", "this");
            lightGallery(".photo_gallery","a");
        }
    });

})(jQuery);

// eslint-disable-next-line no-undef
ready(() => {

    // ПЕРЕИМЕНОВЫВАЕТ КНОПКУ У ТИЗЕРА ТЕРМИНА НА СТРАНИЦЕ КАТАЛОГА
    document.querySelectorAll(".teaser-term-algus-engine-catalog-vocabulary-teaser-1").forEach((teaser) => {
        if (teaser.querySelectorAll(".field-list li").length > 2) {
            teaser.querySelector(".btn").innerText = "Все категории техники";
        }
    });
    // end

    // ПОДВАЛ. СВЕРНУТЬ/РАЗВЕРНУТЬ ПУНКТЫ НА МОБИЛЬНОМ УСТРОЙСТВЕ
    // ДОБАВЛЕНИЕ И УДАЛЕНИЕ СОБЫТИЯ
    document.querySelectorAll(".footer__col").forEach((column) => {
        let footerTitle = column.querySelector(".footer__title");
        let eventFooterMenu = function(e) {
            e.currentTarget.parentElement.classList.toggle("is-open");
        };
        if (document.body.offsetWidth <= 1024) {
            footerTitle.addEventListener("click", eventFooterMenu, false);
        } else {
            footerTitle.removeEventListener("click", eventFooterMenu, false);
        }
        window.addEventListener('resize', (event) => {
            // console.log(document.body.offsetWidth);
            if (document.body.offsetWidth <= 1024) {
                footerTitle.addEventListener("click", eventFooterMenu, false);
            } else {
                footerTitle.removeEventListener("click", eventFooterMenu, false);
            }
        }, true);
    });


    // end

    // проставляем активный класс для тегов категорий новостей и статей
    switch (document.location.pathname) {
        case "/news":
            document.querySelectorAll(".content-page__header .teaser")[0].querySelector("a").classList.add("active");
            break;
        case "/articles":
            document.querySelectorAll(".content-page__header .teaser")[0].querySelector("a").classList.add("active");
            break;
        case "/customers/dealers":
            document.querySelectorAll(".content-page__header .teaser")[0].querySelector("a").classList.add("active");
            break;
        default:
            break;
    }
    // END

});
